import { useState, useCallback } from 'react';

export const useEventsFiltering = () => {
  const [selectedEventType, setSelectedEventType] = useState('All');
  const [columnFilters, setColumnFilters] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5,
  });

  const eventTypes = ['All', 'Webinars', 'In-Person', 'Podcast'];

  const handleCriteriaChange = useCallback((type) => {
    setSelectedEventType(type);
    const searchTerm = type === 'Webinars' ? 'webinar'
      : type === 'All' ? '' : type;
    
    // Update column filters using React Table's built-in filtering
    if (searchTerm === '') {
      setColumnFilters([]);
    } else {
      setColumnFilters([{ id: 'combined', value: searchTerm }]);
    }
    // Reset to the first page when filtering
    setPagination({ pageIndex: 0, pageSize: 5 });
  }, []);

  return {
    selectedEventType,
    columnFilters,
    pagination,
    eventTypes,
    setColumnFilters,
    setPagination,
    handleCriteriaChange,
  };
};
